import React from "react";
import { VISA_OPTIONS, SECTOR_OPTIONS } from "@/lib/constants";
import { CityAutocomplete } from "./CityAutocomplete";

export function Step3Profile({ t, profile, setProfile }) {
  const set = (k, v) => setProfile({ ...profile, [k]: v });
  return (
    <div data-testid="wizard-step-3">
      <h2 className="font-heading font-bold text-3xl lg:text-4xl text-[#292524] mb-2">{t.wizard.s3.title}</h2>
      <p className="text-[#57534E] mb-8">{t.wizard.s3.sub}</p>

      <div className="space-y-6">
        <div>
          <label className="block mb-3 font-semibold text-[#292524]">{t.wizard.s3.visa}</label>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
            {VISA_OPTIONS.map((v) => (
              <button
                key={v}
                onClick={() => set("visa", v)}
                className={`pill-card !justify-center !text-center text-sm ${profile.visa === v ? "active" : ""}`}
                data-testid={`visa-option-${v}`}
              >
                <span className="font-semibold">{t.visas[v]}</span>
              </button>
            ))}
          </div>
        </div>

        <div>
          <label className="block mb-2 font-semibold text-[#292524]">{t.wizard.s3.location}</label>
          <CityAutocomplete
            value={profile.location}
            onChange={(v) => set("location", v)}
            placeholder={t.wizard.s3.location_ph}
          />
        </div>

        <div>
          <label className="block mb-3 font-semibold text-[#292524]">{t.wizard.s3.sector}</label>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
            {SECTOR_OPTIONS.map(({ key, icon: Icon }) => (
              <button
                key={key}
                onClick={() => set("sector", key)}
                className={`pill-card ${profile.sector === key ? "active" : ""}`}
                data-testid={`sector-option-${key}`}
              >
                <Icon className="w-4 h-4 text-[#D95D39]" />
                <span>{t.sectors[key]}</span>
              </button>
            ))}
          </div>
        </div>

        <div>
          <label className="block mb-2 font-semibold text-[#292524]">{t.wizard.s3.notes}</label>
          <textarea
            className="input !min-h-[90px]"
            placeholder={t.wizard.s3.notes_ph}
            value={profile.notes}
            onChange={(e) => set("notes", e.target.value)}
            data-testid="notes-input"
          />
        </div>
      </div>
    </div>
  );
}
